import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import flashRedirect from 'state/actions/flashRedirect';
import postForm from 'utils/postForm';

const mapDispatchToProps = dispatch => ({
  onSubmit: async (data) => {
    const resp = await dispatch(
      postForm(
        'customer',
        R.prop('customerId', data),
        'delete',
      )(data),
    );

    if (!resp.errors) {
      dispatch(
        flashRedirect([
          {
            message: 'Successfully deleted customer.',
            type: 'success',
            position: 'sticky',
          },
        ], {
          type: 'ORGANISATION_CUSTOMERS',
        }),
      );
      return null;
    }

    return resp;
  },
});

const OrganisationDeleteForm = compose(
  withProps({
    fields: [
      {
        type: 'text',
        name: 'customerId',
        label: 'Customer ID',
        required: true,
        hidden: true,
      },
    ],
    submitLabel: 'Delete',
  }),
  connect(
    null,
    mapDispatchToProps,
  ),
)(FormBuilder);

export default OrganisationDeleteForm;

